import { Component, Input, OnInit } from "@angular/core";
import {
  faAngleDown,
  faAngleUp,
  faCar,
  faCarSide,
  faChartLine,
  faCogs,
  faHandHoldingDollar,
  faMicrochip,
  faPrint,
  faTablet,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown, DropdownOptions, initFlowbite } from "flowbite";
import { GENERIC_PROFILE_PIC, STORAGE_KEYS } from "../../constants";
import { UserInfoService } from "../../services/user-info.service";
import { HomeService } from "src/app/services/home/home.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-sidenavbar",
  templateUrl: "./sidenavbar.component.html",
  styleUrls: ["./sidenavbar.component.css"],
})
export class SidenavbarComponent implements OnInit {
  @Input()
  showSideMenu!: boolean;
  //Icons imports
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  displayedModule: string = "";
  displayedSubModule: string = "Booking";
  userInfo: { [key: string]: any } = {};
  profilePic: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(
    GENERIC_PROFILE_PIC,
  );
  environment = environment;

  menus: any[] = [];
  selectedMenu: any[] = [];
  modules: any[] = [];
  notPageSubmodules = [
    {
      name: "Outstanding Registration",
      path: "Services/SalesReportService.asmx/OutstandingRegistration",
    },
    {
      name: "Price List",
      path: "PriceList.aspx",
    },
  ];
  module_icons = [
    faCogs,
    faUser,
    faPrint,
    faUser,
    faCar,
    faChartLine,
    faPrint,
    faCarSide,
    faMicrochip,
    faPrint,
    faTablet,
  ];
  menuName: string = "";

  departmentsBtns = [
    {
      color: "regular-btn sales-btn",
      icon: faHandHoldingDollar,
      text: "Sales",
      menu_id: "KAPS",
    },
    {
      color: "regular-btn hr-btn",
      icon: faUsers,
      text: "HR",
      menu_id: "ELEAVE",
    },
    {
      color: "regular-btn cd-btn",
      icon: faCar,
      text: "C&D",
      menu_id: "ONLINESALES",
    },
  ];

  // Declare dropdown items
  dropdown: Dropdown | null = null;

  protected readonly STORAGE_KEYS = STORAGE_KEYS;

  constructor(
    private userInfoService: UserInfoService,
    private sanitizer: DomSanitizer,
    private homeService: HomeService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.showSideMenu = window.innerWidth >= 640;
    this.updateUserInfo();
    this.switchMenu(this.menuName);
    initFlowbite();
    const $targetEl: HTMLElement | null =
      document.getElementById("dropdownMenu");
    const $triggerEl: HTMLElement | null =
      document.getElementById("dropdownButton");
    const options: DropdownOptions = { triggerType: "click" };
    if ($targetEl && $triggerEl) {
      this.dropdown = new Dropdown($targetEl, $triggerEl, options);
    }
    this.getCurrentRoute();
  }

  switchMenu(menuName: string) {
    menuName = menuName || "KAPS";
    this.getMenus(menuName);
  }

  toggleModuleDropdown(moduleName: string) {
    this.displayedModule =
      this.displayedModule == moduleName.toLowerCase()
        ? ""
        : moduleName.toLowerCase();
  }

  getMenus(menu_id: string) {
    this.homeService.getLoginUser().subscribe((response) => {
      const menuKeys = Object.keys(
        response.body.user.permissions.menus,
      );

      menuKeys.forEach((key) => {
        const menu = response.body.user.permissions.menus[key];
        this.menus.push(menu);
      });

      this.selectedMenu = this.menus.filter(
        (menu) => menu.menu_id === menu_id,
      );
      this.modules = this.selectedMenu[0].modules;

      this.modules = this.modules.map((module, index) => ({
        ...module,
        icon: this.module_icons[index] || faCogs,
      }));
    });
  }

  showError() {
    alert(
      "Error: Mapping has not been set up for this submodule yet. Please contact the administrator.",
    );
  }

  updateUserInfo() {
    this.userInfoService.userInfo$.subscribe((info) => {
      this.userInfo = info;

      // set profile pic
      const profilePic =
        this.userInfo[
          STORAGE_KEYS.USER_INFO["PROFILE_PIC"].sessionKey
        ] ?? GENERIC_PROFILE_PIC;
      this.profilePic =
        this.sanitizer.bypassSecurityTrustUrl(profilePic);

      // set company info
      const selectedCompanyCode =
        this.userInfo[
          STORAGE_KEYS.USER_INFO["SELECTED_COMPANY"].sessionKey
        ] ?? "";
    });
  }

  getCurrentRoute(): void {
    const urlSegments = this.router.url
      .split("/")
      .filter((segment) => segment);
    if (urlSegments.length >= 2) {
      this.displayedModule = urlSegments[0].replace(/-/g, " ");
      this.displayedSubModule = urlSegments[1].replace(/-/g, " ");
    }
  }

  openRoute(route: string, name: string, templateName?: string): void {
    if (this.isNotPageSubmodule(name)) {
      const selectedPath = this.notPageSubmodules.find(
        (item) => item.name == name,
      )?.path;
      window.open(
        environment.KAPS_V1_DIRECT_URL + selectedPath,
        "_blank",
      );
    } else if (route) {
      this.router.navigate([route]);
    } else if (templateName) {
      window.location.href =
        environment.KAPS_V1_DIRECT_URL + "Home.aspx?goto=" + templateName;
    }
  }

  isNotPageSubmodule(name: string): boolean {
    return this.notPageSubmodules.some(
      (submodule) => submodule.name === name,
    );
  }
}
